<template>
  <div>
    <div class="vgbk-select-container">
      <vgbk-select v-model="selectedVgbk" :project-id="projectId" />
    </div>
    <vgbm-table
      :key="vgbmTableRerenderKey"
      :project-id="projectId"
      :selected-vgbk="selectedVgbk"
      @filtering-reset="handleFilterReset"
      @kks-clicked="handleKksRowClick"
      @results-count-updated="handleResultsCountUpdated"
    />
    <kks-vgbm-modal
      v-if="kksIdForModal"
      ref="modalRef"
      :kks-id="kksIdForModal"
      @hide="rerenderVgbmTable"
    />
  </div>
</template>

<script setup lang="ts">
  import { ref, nextTick } from 'vue';
  import VgbkSelect from '@/components/VgbkSelect/VgbkSelect.vue';
  import VgbmTable from '@/components/VgbmTable/VgbmTable.vue';
  import KksVgbmModal from '@/components/KksVgbmModal/KksVgbmModal.vue';
  import { IVgbkListElementDto } from 'types';

  defineProps<{ projectId: string }>();
  const kksIdForModal = ref<string | null>(null);
  const selectedVgbk = ref<IVgbkListElementDto | null>(null);
  const vgbmTableRerenderKey = ref(0);

  const emit = defineEmits<{
    (e: 'results-count-updated', count: number): void;
  }>();

  function rerenderVgbmTable() {
    vgbmTableRerenderKey.value += 1;
  }

  function handleFilterReset() {
    selectedVgbk.value = null;
  }

  function handleKksRowClick(kksId: string) {
    kksIdForModal.value = kksId;
    nextTick(showKksVgbmModal);
  }

  function handleResultsCountUpdated(count: number) {
    emit('results-count-updated', count);
  }

  const modalRef = ref<InstanceType<typeof KksVgbmModal> | null>(null);
  function showKksVgbmModal() {
    modalRef.value?.show();
  }
</script>

<style lang="scss" scoped>
  .vgbk-select-container {
    width: 40%;
    display: flex;
  }
</style>
